var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftArrow = function SvgLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M11.572 21.541a1.585 1.585 0 0 0-.014-2.182L3.6 11.2l7.958-8.16c.584-.598.59-1.575.014-2.181A1.447 1.447 0 0 0 9.47.845L.44 10.102C.16 10.392 0 10.787 0 11.2s.16.808.442 1.098l9.029 9.257a1.447 1.447 0 0 0 2.1-.014"
  })));
};
export default SvgLeftArrow;